import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { energyData } from "variables/lists/markets";
import { markets as markets_txt } from "variables/markets";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Serviceorder } from "components/CustomIcon/CustomIcon";
import { Navigate } from "react-router-dom";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";


const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
    marginLeft: "1px",
    marginTop: "1px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
  planmenubuttonfspressed: {
    background: "#9798A0"
  },
  "@keyframes flicker": {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0.8
    }
  },
  flicker: {
    animationName: "$flicker",
    animationDuration: "2000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out"
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? "paused" : "running"
  })
}));

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: 14px;
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;
const Container = styled.div`
  border: 0;
  display: flex;
  padding: 0 6px;
  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0px;
  color: #ffffff;
  background: #ffffff;
  width: 100%;
  position: relative;
  min-width: 0;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`

  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStylesTable = makeStyles(tablestyles);

function CustomCardMarkets(props) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const markets_update = permis.includes("markets_update");
  const tableclasses = useStylesTable();

  const [redirState, setRedirState] = useState(false);
  const [marketId, setMarketId] = useState("");
  const [marketName, setMarketName] = useState("");
  const [marketAdminVisibility, setMarketAdminVisibility] = useState("");
  const [initialtabindex, setInitialtabindex] = useState("");
  const [initialsubtabindex, setInitialsubtabindex] = useState("");


  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/markets/selectedmarket/",
        state: { marketId, marketName, marketAdminVisibility, initialtabindex, initialsubtabindex },
      }}
      state={{ marketId, marketName, marketAdminVisibility, initialtabindex, initialsubtabindex }}
    />
  );

  const { markets } = props;
  const marketsColumns = [
    {
      name: markets_txt.general.name,
      selector: (row) => row.parameters.name,
      sortable: true,
      compact: true,
    },
    {
      name: markets_txt.general.energy,
      sortable: true,
      selector: (row) => row.parameters.energy,
      cell: (row) => row.parameters.energy ? energyData.find((x) => x.id == row.parameters.energy)?.name : ""
    },
    {
      name: "",
      compact: true,
      sortable: false,
      width: "6rem",
      right: true,
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title={markets_txt.seemarketdetails}>
              <Button
                onClick={MarketDetail(row)}
                color={"info"}
                className={tableclasses.actionButtonDense}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {markets_update && (
              <Tooltip title={markets_txt.gotoserviceorders}>
                <Button
                  onClick={ServiceOrder(row)}
                  color={"warning"}
                  className={tableclasses.actionButtonDense}
                >
                  <Serviceorder fontSize="large" />
                </Button>
              </Tooltip>
            )}
          </div>
        </>
      ),
    }
  ]


  const MarketDetail = (row) => async () => {
    setMarketId(row.id);
    setMarketName(row.parameters.name);
    setMarketAdminVisibility(row.parameters.hasadminvisibility)
    setRedirState(true);

  };

  const ServiceOrder = (row) => async () => {
    setMarketId(row.id);
    setMarketName(row.parameters.name);
    setMarketAdminVisibility(row.parameters.hasadminvisibility)
    setInitialtabindex("1");
    setInitialsubtabindex(4);
    setRedirState(true);

  };

  return (
    <div>
      <Card>
        <TitleContainer>
          <CardTitle>{markets_txt.markets}</CardTitle>
        </TitleContainer>
        <Container>
          <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            noDataComponent={<NoData>{markets_txt.nomarkets}</NoData>}
            noHeader={true}
            columns={marketsColumns}
            persistTableHead
            pagination
            dense
            data={markets}
            paginationComponentOptions={{
              noRowsPerPage: true,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            selectableRows={false}
            defaultPageSize={10}
            defaultSortFieldId={1}
            manual={true}
          />

        </Container>
      </Card>
      {redirecting}
    </div>
  );
}

CustomCardMarkets.propTypes = {
  markets: PropTypes.object,
};

export default CustomCardMarkets;
